import { createApp } from 'vue'
import App from './AboutPowerTalent.vue'

createApp(App).mount('#app-about-power-talent')
